import $ from "jquery"
import CryptoJS from "crypto-js";

class ApiService {
    //物件建立時產生
    constructor(router) {
        this.url = process.env.VUE_APP_API_URL
        this.key = ''
        this.header = {}
        this.isDecryption = false
        this.userData = {}
        this.token = ""
        this.router = router; // 保存 router 實例
    }

    init(data) { //初始化header
        this.header = {
            token: data.token
        }
    }
    //user Token 處理成32長度
    getUserToken(token) {
        // console.log('getUserToken token->',token)
        let hToken = token.substr(0, 16)
        // console.log('getUserToken hToken ['+hToken.length+']->',hToken)
        let fToken = token.substr(token.length - 16, token.length)
        // console.log('getUserToken hToken ['+fToken.length+']->',fToken)
        return hToken + fToken
    }
    setToken(token) {
        this.token = token;
        this.header = {
            token: this.token
        }
    }
    getToken() {
        return this.token;
    }
    //解密
    AES_ECB_DECRYPT(token) {
        if (token == '') {
            return;
        }
        var decrypt = CryptoJS.AES.decrypt(
            token,
            CryptoJS.enc.Utf8.parse(this.key),
            {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7
            }
        );
        return decrypt.toString(CryptoJS.enc.Utf8)
    }
    //資料加密
    AES_ECB_ENCRYPT(parameter) {
        // console.log('AES_ECB_ENCRYPT = ',this.header.token)
        let encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(JSON.stringify(parameter)), CryptoJS.enc.Utf8.parse(this.key), {
            iv: CryptoJS.enc.Utf8.parse(this.iv),
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });
        return encrypted.ciphertext.toString(CryptoJS.enc.Base64)
    }
    //api請求body資料加密
    apiDataEncrypt(parameter) {
        if (this.isDecryption) { //需要加密
            parameter = {
                data: this.AES_ECB_ENCRYPT(parameter)
            }
            parameter = JSON.stringify(parameter)
        } else { //資料不需要加密
            // parameter = JSON.stringify(parameter)
        }
        return parameter
    }
    //api回應資料解密 + 判斷登入狀態異常登出作業
    apiDataDecrypt(parameter) {
        if (this.isDecryption) { //需要解密
            parameter = JSON.parse(this.AES_ECB_DECRYPT(parameter.data)) ? JSON.parse(this.AES_ECB_DECRYPT(parameter.data)) : { code: 5000, showmsg: '資料解析異常' }
        }

        if (parameter.code > 3000) {
            // alert(`[${parameter.code}] : 帳號資料異動，或者異常請重新登入` )
            this.router.push('/Login')
        }
        return parameter
    }
    //處理login&註冊時產生token
    userInputEncrypt() {
        let token = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex)
        return token
    }
    //get加密
    getMethodEncryp(parameter) {
        if (this.isDecryption) { //需要加密
            parameter = {
                data: this.AES_ECB_ENCRYPT(parameter)
            }
            parameter = "data=" + parameter
        } else { //資料不需要加密
            // parameter = JSON.stringify(parameter)
            let url = ''
            Object.keys(parameter).forEach((key) => {
                url = url + key + '=' + parameter[key] + '&'
            });
            parameter = url.substring(0, url.length - 1);
        }
        return parameter
    }
    //執行POST
    postApi(data) {
        let self = this
        $.ajax({
            url: data.url,              // 要傳送的頁面
            method: 'POST',               // 使用 POST 方法傳送請求
            dataType: 'json',             // 回傳資料會是 json 格式
            headers: self.header,
            // contentType : 'application/json; charset=utf-8', // 要送到server的資料型態
            data: self.apiDataEncrypt(data.parameter),
            success: function (res) {
                console.log(res)
                // 成功以後會執行這個方法
                res = self.apiDataDecrypt(res)
                // if (res.code < 0 ){
                //     alert('error['+res.code +'] : ' + res.message )
                // }
                data.success(res)
            },
            xhr: function () {
                var xhr = new window.XMLHttpRequest(); // 建立xhr(XMLHttpRequest)物件
                xhr.upload.addEventListener("progress", function (progressEvent) { // 監聽ProgressEvent
                    if (progressEvent.lengthComputable) {
                        var percentComplete = progressEvent.loaded / progressEvent.total;
                        var percentVal = Math.round(percentComplete * 100);
                        if (data.progress) {
                            console.log("上傳進度為：" + progressEvent.loaded + " of " + progressEvent.total + " bytes" + '；百分比為：' + progressEvent.loaded / progressEvent.total);
                            data.progress({
                                mag: "上傳進度為：" + progressEvent.loaded + " of " + progressEvent.total + " bytes" + '；百分比為：' + progressEvent.loaded / progressEvent.total,
                                loaded: progressEvent.loaded,
                                total: progressEvent.total,
                                percentComplete: percentComplete,
                                percentVal: percentVal
                            })
                        }
                    }
                }, false);
                return xhr; // 注意必須將xhr(XMLHttpRequest)物件回傳
            },
            error: function () {
                alert('error[500] : serveer error')
                data.success({ code: 500 })
            }
        })
    }
    postFormDataApi(data) {
        let self = this
        $.ajax({
            url: data.url,              // 要傳送的頁面
            method: 'POST',               // 使用 POST 方法傳送請求
            dataType: 'json',             // 回傳資料會是 json 格式
            headers: self.header,
            data: data.parameter,  // 將表單資料用打包起來送出去
            contentType: false,
            cache: false,
            processData: false,
            success: function (res) {
                console.log(res)
                // 成功以後會執行這個方法
                res = self.apiDataDecrypt(res)

                if (res.code == -9999) {
                    alert(res.msg);
                }
                data.success(res)
            },
            xhr: function () {
                var xhr = new window.XMLHttpRequest(); // 建立xhr(XMLHttpRequest)物件
                xhr.upload.addEventListener("progress", function (progressEvent) { // 監聽ProgressEvent
                    if (progressEvent.lengthComputable) {
                        var percentComplete = progressEvent.loaded / progressEvent.total;
                        var percentVal = Math.round(percentComplete * 100);
                        if (data.progress) {
                            console.log("上傳進度為：" + progressEvent.loaded + " of " + progressEvent.total + " bytes" + '；百分比為：' + progressEvent.loaded / progressEvent.total);
                            data.progress({
                                mag: "上傳進度為：" + progressEvent.loaded + " of " + progressEvent.total + " bytes" + '；百分比為：' + progressEvent.loaded / progressEvent.total,
                                loaded: progressEvent.loaded,
                                total: progressEvent.total,
                                percentComplete: percentComplete,
                                percentVal: percentVal
                            })
                        }
                    }
                }, false);
                return xhr; // 注意必須將xhr(XMLHttpRequest)物件回傳
            },
            error: function () {
                alert('error[500] : serveer error')
                data.success({ code: 500 })
            }
        })
    }
    //執行PUT
    putApi(data) {
        let self = this
        $.ajax({
            url: data.url,              // 要傳送的頁面
            method: 'PUT',               // 使用 POST 方法傳送請求
            dataType: 'json',             // 回傳資料會是 json 格式
            headers: self.header,
            contentType: 'application/json; charset=utf-8', // 要送到server的資料型態
            data: self.apiDataEncrypt(data.parameter),
            success: function (res) {
                console.log(res)
                // 成功以後會執行這個方法
                res = self.apiDataDecrypt(res)
                // if (res.code < 0 ){
                //     alert('error['+res.code +'] : ' + res.message )
                // }
                data.success(res)
            },
            xhr: function () {
                var xhr = new window.XMLHttpRequest(); // 建立xhr(XMLHttpRequest)物件
                xhr.upload.addEventListener("progress", function (progressEvent) { // 監聽ProgressEvent
                    if (progressEvent.lengthComputable) {
                        var percentComplete = progressEvent.loaded / progressEvent.total;
                        var percentVal = Math.round(percentComplete * 100);
                        if (data.progress) {
                            console.log("上傳進度為：" + progressEvent.loaded + " of " + progressEvent.total + " bytes" + '；百分比為：' + (progressEvent.loaded / progressEvent.total) * 100 + '%');
                            data.progress({
                                mag: "上傳進度為：" + progressEvent.loaded + " of " + progressEvent.total + " bytes" + '；百分比為：' + (progressEvent.loaded / progressEvent.total) * 100 + '%',
                                loaded: progressEvent.loaded,
                                total: progressEvent.total,
                                percentComplete: percentComplete,
                                percentVal: percentVal
                            })
                        }
                    }
                }, false);
                return xhr; // 注意必須將xhr(XMLHttpRequest)物件回傳
            },
            error: function () {
                alert('error[500] : serveer error')
                data.success({ code: 500 })
            }
        })
    }
    //執行GET
    getApi(data) {
        // {url,parameter,callback}
        // console.log("header");
        // console.log(this.header);
        // console.log(data.url);
        let self = this
        if (data.parameter) {
            data.url = data.url + "?" + this.getMethodEncryp(data.parameter)
        }
        $.ajax({
            url: data.url,              // 要傳送的頁面
            method: 'GET',               // 使用 POST 方法傳送請求
            dataType: 'json',             // 回傳資料會是 json 格式
            headers: self.header,
            success: function (res) {
                // 成功以後會執行這個方法
                // if (res.code < 0 ){
                //     alert('error['+res.code +'] : ' + res.message )
                // }
                res = self.apiDataDecrypt(res)
                if (res.code == -9999) {
                    alert(res.msg);
                }
                data.success(res)
            },
            error: function () {
                // alert('error[500] : serveer error')
                data.success({ code: 500 })
            }
        })
    }

    //執行DELECT
    delApi(data) {
        let self = this
        $.ajax({
            url: data.url,              // 要傳送的頁面
            method: 'DELETE',               // 使用 POST 方法傳送請求
            dataType: 'json',             // 回傳資料會是 json 格式
            headers: self.header,
            contentType: 'application/json; charset=utf-8', // 要送到server的資料型態
            data: self.apiDataEncrypt(data.parameter),
            success: function (res) {
                console.log(res)
                // 成功以後會執行這個方法
                res = self.apiDataDecrypt(res)
                // if (res.code < 0 ){
                //     alert('error['+res.code +'] : ' + res.message )
                // }
                if (res.code == -9999) {
                    alert(res.msg);
                }
                data.success(res)
            },
            error: function () {
                alert('error[500] : serveer error')
                data.success({ code: 500 })
            }
        })
    }

    /*
    api區
    */
    //取得測試資料
    getTestTableAPI(parameter, callback) {
        return new Promise((resolve, reject) => {
            this.getApi({
                url: this.url + "patient/list",
                parameter: parameter,
                success: function (res) {
                    resolve(res)
                }, error: (err) => [
                    reject(err)
                ]
            })
        })
        //呼叫post方法

    }

    async simulationAPI() {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve({ code: 200, msg: 'success' })
            }, 1000);
        })
    }

    //user - 1.1登入 f
    async login(parameter) {
        //處理密碼加密
        //呼叫post方法
        return new Promise((resolve, reject) => {
            this.postFormDataApi({
                url: this.url + "users/doctorLogin",
                parameter: parameter,
                success: function (res) {
                    resolve(res)
                },
                error: (err) => [
                    reject(err)
                ]
            })
        })
    }

    async getBulletinListAPI(parameter) {
        return new Promise((resolve, reject) => {
            this.getApi({
                url: this.url + "bulletin/list",
                success: function (res) {
                    resolve(res)
                }, error: (err) => [
                    reject(err)
                ]
            })
        })
    }


    async getPatientListAPI(parameter) {
        return new Promise((resolve, reject) => {
            this.getApi({
                url: this.url + "patient/list",
                parameter: parameter,
                success: function (res) {
                    resolve(res)
                }, error: (err) => [
                    reject(err)
                ]
            })
        })
    }

    async getClinicListAPI(parameter) {
        return new Promise((resolve, reject) => {
            this.getApi({
                url: this.url + "patient/clinicList",
                parameter: parameter,
                success: function (res) {
                    resolve(res)
                }, error: (err) => [
                    reject(err)
                ]
            })
        })
    }

    async createPatientAPI(parameter) {
        //處理密碼加密
        //呼叫post方法
        return new Promise((resolve, reject) => {
            this.postFormDataApi({
                url: this.url + "patient/create",
                parameter: parameter,
                success: function (res) {
                    resolve(res)
                },
                error: (err) => [
                    reject(err)
                ]
            })
        })
    }

    async updatePatientAPI(parameter) {
        //處理密碼加密
        //呼叫post方法
        return new Promise((resolve, reject) => {
            this.postFormDataApi({
                url: this.url + "patient/update",
                parameter: parameter,
                success: function (res) {
                    resolve(res)
                },
                error: (err) => [
                    reject(err)
                ]
            })
        })
    }

    async getPatientDetailAPI(parameter) {
        return new Promise((resolve, reject) => {
            this.getApi({
                url: `${this.url}patient/detail/${parameter.patient_sn}`,
                success: function (res) {
                    resolve(res)
                }, error: (err) => [
                    reject(err)
                ]
            })
        })
    }

    async getPatientPlanListAPI(parameter) {
        return new Promise((resolve, reject) => {
            this.getApi({
                url: `${this.url}patient/planList/${parameter.patient_sn}`,
                success: function (res) {
                    resolve(res)
                }, error: (err) => [
                    reject(err)
                ]
            })
        })
    }

    async createPlanAPI(parameter, progressEvent) {
        //處理密碼加密
        //呼叫post方法
        return new Promise((resolve, reject) => {
            this.postFormDataApi({
                url: this.url + "plan/create",
                parameter: parameter,
                success: function (res) {
                    resolve(res)
                },
                progress: (res) => {
                    console.log(res)
                    progressEvent(res)
                },
                error: (err) => [
                    reject(err)
                ]
            })
        })
    }

    async getPendingConfirmPlansAPI(parameter = {}) {
        return new Promise((resolve, reject) => {
            this.getApi({
                url: `${this.url}plan/getPendingConfirmPlans`,
                parameter: parameter,
                success: function (res) {
                    resolve(res)
                },
                error: (err) => [
                    reject(err)
                ]
            })
        })
    }

    async getPlanDetailAPI(parameter) {
        return new Promise((resolve, reject) => {
            this.getApi({
                url: `${this.url}plan/detail/${parameter.plan_sn}`,
                success: function (res) {
                    resolve(res)
                }, error: (err) => [
                    reject(err)
                ]
            })
        })
    }

    async getPlanPhotoAPI(parameter) {
        return new Promise((resolve, reject) => {
            this.getApi({
                url: `${this.url}plan/photo/${parameter.plan_sn}`,
                success: function (res) {
                    resolve(res)
                }, error: (err) => [
                    reject(err)
                ]
            })
        })
    }

    async uploadPlanPhotoAPI(parameter, progressEvent = null) {
        //處理密碼加密
        //呼叫post方法
        return new Promise((resolve, reject) => {
            this.postFormDataApi({
                url: this.url + "plan/uploadPhoto",
                parameter: parameter,
                success: function (res) {
                    resolve(res)
                },
                progress: (res) => {
                    console.log(res)
                    if (progressEvent) {
                        progressEvent(res)
                    }
                },
                error: (err) => [
                    reject(err)
                ]
            })
        })
    }

    async getPlanComplaintAPI(parameter) {
        return new Promise((resolve, reject) => {
            this.getApi({
                url: `${this.url}plan/complaint/${parameter.plan_sn}`,
                success: function (res) {
                    resolve(res)
                }, error: (err) => [
                    reject(err)
                ]
            })
        })
    }

    async uploadComplaintAPI(parameter, progressEvent = null) {
        //處理密碼加密
        //呼叫post方法
        return new Promise((resolve, reject) => {
            this.postFormDataApi({
                url: this.url + "plan/uploadComplaint",
                parameter: parameter,
                success: function (res) {
                    resolve(res)
                },
                progress: (res) => {
                    console.log(res)
                    if (progressEvent) {
                        progressEvent(res)
                    }
                },
                error: (err) => [
                    reject(err)
                ]
            })
        })
    }

    async getDoctorOrder(parameter) {
        return new Promise((resolve, reject) => {
            this.getApi({
                url: `${this.url}plan/doctorOrder/${parameter.plan_sn}`,
                success: function (res) {
                    resolve(res)
                }, error: (err) => [
                    reject(err)
                ]
            })
        })
    }

    async uploadDoctorOrderAPI(parameter, progressEvent = null) {
        //處理密碼加密
        //呼叫post方法
        return new Promise((resolve, reject) => {
            this.postFormDataApi({
                url: this.url + "plan/uploadDoctorOrder",
                parameter: parameter,
                success: function (res) {
                    resolve(res)
                },
                progress: (res) => {
                    console.log(res)
                    if (progressEvent) {
                        progressEvent(res)
                    }
                },
                error: (err) => [
                    reject(err)
                ]
            })
        })
    }

    async getScanAPI(parameter) {
        return new Promise((resolve, reject) => {
            this.getApi({
                url: `${this.url}plan/scan/${parameter.plan_sn}`,
                success: function (res) {
                    resolve(res)
                }, error: (err) => [
                    reject(err)
                ]
            })
        })
    }

    async uploadScanFileAPI(parameter, progressEvent = null) {
        //處理密碼加密
        //呼叫post方法
        return new Promise((resolve, reject) => {
            this.postFormDataApi({
                url: this.url + "plan/uploadScanFile",
                parameter: parameter,
                success: function (res) {
                    resolve(res)
                },
                progress: (res) => {
                    console.log(res)
                    if (progressEvent) {
                        progressEvent(res)
                    }
                },
                error: (err) => [
                    reject(err)
                ]
            })
        })
    }
    //removeScan
    async removeScanFileAPI(parameter, progressEvent = null) {
        return new Promise((resolve, reject) => {
            this.postFormDataApi({
                url: this.url + "plan/removeScan",
                parameter: parameter,
                success: function (res) {
                    resolve(res)
                },
                progress: (res) => {
                    console.log(res)
                    if (progressEvent != null) {
                        progressEvent(res)
                    }
                },
                error: (err) => [
                    reject(err)
                ]
            })
        })
    }

    async getDesignFileAPI(parameter) {
        return new Promise((resolve, reject) => {
            this.getApi({
                url: `${this.url}plan/design/${parameter.plan_sn}`,
                success: function (res) {
                    resolve(res)
                }, error: (err) => [
                    reject(err)
                ]
            })
        })
    }

    async getDesignTmpIprAPI(parameter) {
        return new Promise((resolve, reject) => {
            this.getApi({
                url: `${this.url}plan/getDesignTempIPR/${parameter.tmp_sn}`,
                success: function (res) {
                    resolve(res)
                }, error: (err) => [
                    reject(err)
                ]
            })
        })
    }

    async getDoctorProfileAPI() {
        return new Promise((resolve, reject) => {
            this.getApi({
                url: `${this.url}doctor/profile`,
                success: function (res) {
                    resolve(res)
                }, error: (err) => [
                    reject(err)
                ]
            })
        })
    }

    async updateDoctorProfileAPI(parameter, progressEvent = null) {
        return new Promise((resolve, reject) => {
            this.postFormDataApi({
                url: this.url + "doctor/updateProfile",
                parameter: parameter,
                success: function (res) {
                    resolve(res)
                },
                progress: (res) => {
                    console.log(res)
                    if (progressEvent != null) {
                        progressEvent(res)
                    }
                },
                error: (err) => [
                    reject(err)
                ]
            })
        })
    }

    async resetPasswordAPI(parameter, progressEvent = null) {
        return new Promise((resolve, reject) => {
            this.postFormDataApi({
                url: this.url + "doctor/resetPassword",
                parameter: parameter,
                success: function (res) {
                    resolve(res)
                },
                progress: (res) => {
                    console.log(res)
                    if (progressEvent != null) {
                        progressEvent(res)
                    }
                },
                error: (err) => [
                    reject(err)
                ]
            })
        })
    }

    async getDoctorServiceClinicListAPI() {
        return new Promise((resolve, reject) => {
            this.getApi({
                url: `${this.url}doctor/clinicList`,
                success: function (res) {
                    resolve(res)
                }, error: (err) => [
                    reject(err)
                ]
            })
        })
    }

    async removeServiceAPI(parameter, progressEvent = null) {
        return new Promise((resolve, reject) => {
            this.postFormDataApi({
                url: this.url + "doctor/removeService",
                parameter: parameter,
                success: function (res) {
                    resolve(res)
                },
                progress: (res) => {
                    console.log(res)
                    if (progressEvent != null) {
                        progressEvent(res)
                    }
                },
                error: (err) => [
                    reject(err)
                ]
            })
        })
    }

    async createAndJoinAPI(parameter, progressEvent = null) {
        return new Promise((resolve, reject) => {
            this.postFormDataApi({
                url: this.url + "doctor/createAndJoin",
                parameter: parameter,
                success: function (res) {
                    resolve(res)
                },
                progress: (res) => {
                    console.log(res)
                    if (progressEvent != null) {
                        progressEvent(res)
                    }
                },
                error: (err) => [
                    reject(err)
                ]
            })
        })
    }

    async getClinicDetailAPI(parameter) {
        return new Promise((resolve, reject) => {
            this.getApi({
                url: `${this.url}doctor/clinicDetail/${parameter.clinic_sn}`,
                success: function (res) {
                    resolve(res)
                }, error: (err) => [
                    reject(err)
                ]
            })
        })
    }

    async updateClinicProfileAPI(parameter, progressEvent = null) {
        return new Promise((resolve, reject) => {
            this.postFormDataApi({
                url: this.url + "doctor/updateClinicProfile",
                parameter: parameter,
                success: function (res) {
                    resolve(res)
                },
                progress: (res) => {
                    console.log(res)
                    if (progressEvent != null) {
                        progressEvent(res)
                    }
                },
                error: (err) => [
                    reject(err)
                ]
            })
        })
    }

    async getIprHistoryAPI(parameter) {
        return new Promise((resolve, reject) => {
            this.getApi({
                url: `${this.url}plan/iprHistory/${parameter.patient_sn}`,
                success: function (res) {
                    resolve(res)
                }, error: (err) => [
                    reject(err)
                ]
            })
        })
    }

    async getStepListAPI(parameter) {
        return new Promise((resolve, reject) => {
            this.getApi({
                url: `${this.url}plan/stepList/${parameter.plan_sn}`,
                success: function (res) {
                    resolve(res)
                }, error: (err) => [
                    reject(err)
                ]
            })
        })
    }

    async orderStepAPI(parameter, progressEvent = null) {
        return new Promise((resolve, reject) => {
            this.postFormDataApi({
                url: this.url + "plan/orderStep",
                parameter: parameter,
                success: function (res) {
                    resolve(res)
                },
                progress: (res) => {
                    console.log(res)
                    if (progressEvent != null) {
                        progressEvent(res)
                    }
                },
                error: (err) => [
                    reject(err)
                ]
            })
        })
    }

    async removePhotoAPI(parameter, progressEvent = null) {
        return new Promise((resolve, reject) => {
            this.postFormDataApi({
                url: this.url + "plan/removePhoto",
                parameter: parameter,
                success: function (res) {
                    resolve(res)
                },
                progress: (res) => {
                    console.log(res)
                    if (progressEvent != null) {
                        progressEvent(res)
                    }
                },
                error: (err) => [
                    reject(err)
                ]
            })
        })
    }

    async getMessageAPI(parameter) {
        return new Promise((resolve, reject) => {
            this.getApi({
                url: `${this.url}patient/getMessage/${parameter.patient_sn}`,
                success: function (res) {
                    resolve(res)
                }, error: (err) => [
                    reject(err)
                ]
            })
        })
    }

    async readerMassageAPI(parameter, progressEvent = null) {
        return new Promise((resolve, reject) => {
            this.postFormDataApi({
                url: this.url + "patient/readerMassage",
                parameter: parameter,
                success: function (res) {
                    resolve(res)
                },
                progress: (res) => {
                    console.log(res)
                    if (progressEvent != null) {
                        progressEvent(res)
                    }
                },
                error: (err) => [
                    reject(err)
                ]
            })
        })
    }

    async setMessagePlanNoteAPI(parameter, progressEvent = null) {
        return new Promise((resolve, reject) => {
            this.postFormDataApi({
                url: this.url + "patient/setMessagePlanNote",
                parameter: parameter,
                success: function (res) {
                    resolve(res)
                },
                progress: (res) => {
                    console.log(res)
                    if (progressEvent != null) {
                        progressEvent(res)
                    }
                },
                error: (err) => [
                    reject(err)
                ]
            })
        })
    }

    async sendMassageAPI(parameter, progressEvent = null) {
        return new Promise((resolve, reject) => {
            this.postFormDataApi({
                url: this.url + "patient/sendMassage",
                parameter: parameter,
                success: function (res) {
                    resolve(res)
                },
                progress: (res) => {
                    console.log(res)
                    if (progressEvent != null) {
                        progressEvent(res)
                    }
                },
                error: (err) => [
                    reject(err)
                ]
            })
        })
    }

    async getApptAPI(parameter) {
        return new Promise((resolve, reject) => {
            this.getApi({
                url: `${this.url}main/appt?y=${parameter.year}&m=${parameter.month}`,
                success: function (res) {
                    resolve(res)
                }, error: (err) => [
                    reject(err)
                ]
            })
        })
    }

    async getBllForDoctorAPI(parameter) {
        return new Promise((resolve, reject) => {
            this.getApi({
                url: `${this.url}bill/searchInvoices?country=${parameter.country}&year=${parameter.year}&month=${parameter.month}&selectedTags=${parameter.selectedTags}`,
                success: function (res) {
                    resolve(res)
                }, error: (err) => [
                    reject(err)
                ]
            })
        })
    }

    async selectTempPlanAPI(parameter, progressEvent = null) {
        return new Promise((resolve, reject) => {
            this.postFormDataApi({
                url: this.url + "plan/selectTempPlan",
                parameter: parameter,
                success: function (res) {
                    resolve(res)
                },
                progress: (res) => {
                    console.log(res)
                    if (progressEvent != null) {
                        progressEvent(res)
                    }
                },
                error: (err) => [
                    reject(err)
                ]
            })
        })
    }

    async checkMyServiceClinicCodeNum(parameter) {
        return new Promise((resolve, reject) => {
            this.getApi({
                url: `${this.url}doctor/checkMyServiceClinicCodeNum?clinic_codenum=${parameter.clinic_codenum}`,
                success: function (res) {
                    resolve(res)
                }, error: (err) => [
                    reject(err)
                ]
            })
        })
    }

    async checkClinicPatientCno(parameter) {
        return new Promise((resolve, reject) => {
            this.getApi({
                url: `${this.url}patient/checkClinicPatientCno?patient_cno=${parameter.patient_cno}&clinic_sn=${parameter.clinic_sn}`,
                success: function (res) {
                    resolve(res)
                }, error: (err) => [
                    reject(err)
                ]
            })
        })
    }

    async getFreightList(parameter) {
        return new Promise((resolve, reject) => {
            this.getApi({
                url: `${this.url}ship/getFreightList`,
                success: function (res) {
                    resolve(res)
                }, error: (err) => [
                    reject(err)
                ]
            })
        })
    }

    async searchShipList(parameter) {
        return new Promise((resolve, reject) => {
            const searchParameter = `sDate=${parameter.sDate}&eDate=${parameter.eDate}&freight_sn=${parameter.freight_sn}&clinic_sn=${parameter.clinic_sn}`
            this.getApi({
                url: `${this.url}ship/searchShipList?${searchParameter}`,
                success: function (res) {
                    resolve(res)
                }, error: (err) => [
                    reject(err)
                ]
            })
        })
    }

    async getBoardList() {
        return new Promise((resolve, reject) => {
            this.getApi({
                url: `${this.url}board/list`,
                success: function (res) {
                    resolve(res)
                }, error: (err) => [
                    reject(err)
                ]
            })
        })
    }

    async setBoardHandle(parameter, progressEvent = null) {
        return new Promise((resolve, reject) => {
            this.postFormDataApi({
                url: this.url + "board/setHandle",
                parameter: parameter,
                success: function (res) {
                    resolve(res)
                },
                progress: (res) => {
                    console.log(res)
                    if (progressEvent != null) {
                        progressEvent(res)
                    }
                },
                error: (err) => [
                    reject(err)
                ]
            })
        })
    }

    async getOrderRecodeAPI(parameter) {
        return new Promise((resolve, reject) => {
            this.getApi({
                url: this.url + "plan/getOrderRecode",
                parameter: parameter,
                success: function (res) {
                    resolve(res)
                }, error: (err) => [
                    reject(err)
                ]
            })
        })
    }

    async getOrderRecodeByLastOrderDayAPI(parameter) {
        return new Promise((resolve, reject) => {
            this.getApi({
                url: this.url + "plan/getOrderRecodeByLastOrderDay",
                parameter: parameter,
                success: function (res) {
                    resolve(res)
                }, error: (err) => [
                    reject(err)
                ]
            })
        })
    }



}
export default ApiService